/* build/tpl */
import deps from './deps/findPathDeep.js';
import getFindPathDeep from './getFindPathDeep.js';
export default getFindPathDeep(deps);
